module.exports = __webpack_public_path__ + "img/crpt.29462f21.svg";